import { Row } from '@cuemath/comps';
import React from 'react';
import { POCWrapper } from 'screens/student-details/styled-comps';
import { getFormattedDate } from 'utils';
import { CopyButton } from 'comps';
import { Text } from '@cuemath/web-comps';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const CustomRow = styled(Row)`
  margin-bottom: 12px;
`;
const LabelText = styled(Text)`
  min-width: 150px;
`;

const PauseHistoryInfo = props => {
  const { id, classes, end_datetime, start_datetime, leave_type } = props;

  return (
    <POCWrapper>
      <CustomRow alignItems="center">
        <LabelText variant="eyebrow2">Leave type</LabelText>
        <Text variant="body1Medium">{leave_type}</Text>
      </CustomRow>
      <CustomRow alignItems="center">
        <LabelText variant="eyebrow2">Start date</LabelText>
        <Text variant="body1Medium">
          {getFormattedDate(start_datetime * 1000, 'DD MMM YY, hh:mm A')}
        </Text>
      </CustomRow>
      <CustomRow alignItems="center">
        <LabelText variant="eyebrow2">End date</LabelText>
        <Text variant="body1Medium">
          {getFormattedDate(end_datetime * 1000, 'DD MMM YY, hh:mm A')}
        </Text>
      </CustomRow>
      <CustomRow alignItems="center">
        <LabelText variant="eyebrow2">Classes affected</LabelText>
        <Text variant="body1Medium">{classes}</Text>
      </CustomRow>
      <CustomRow alignItems="center">
        <LabelText variant="eyebrow2">Id</LabelText>
      </CustomRow>
      <CopyButton copyMessage="Copy Pause Id" text={id || 'N/A'} />
    </POCWrapper>
  );
};

PauseHistoryInfo.propTypes = {
  id: PropTypes.string,
  classes: PropTypes.number,
  end_datetime: PropTypes.number,
  start_datetime: PropTypes.number,
  leave_type: PropTypes.string,
};

export default PauseHistoryInfo;
